import React, { useState, useEffect } from "react";
import { EditableSelectComponent } from "components/index";
import useWhatsAppTemplates from "hooks/useWhatsappTemplates";
import { extractTemplateParams, getTemplateBody } from "components/customer-chat/util/template-util";

interface WhatsAppTemplateSelectorProps {
  onSelectTemplate: (template: any, params: Record<string, string>) => void;
  incomingSelectedTemplate: string;
}

const WhatsAppTemplateSelector: React.FC<WhatsAppTemplateSelectorProps> = ({
  onSelectTemplate,
  incomingSelectedTemplate,
}) => {
  const templates = useWhatsAppTemplates();
  const [selectedTemplate, setSelectedTemplate] = useState<any>(null);
  // const [templateParams, setTemplateParams] = useState<Record<string, string>>({});

  useEffect(() => {
    if (selectedTemplate) {
      const templateBody = getTemplateBody(selectedTemplate);
      if (templateBody) {
        const params = extractTemplateParams(templateBody);
        const initialParams: Record<string, string> = {};
        params.forEach((param: string) => {
          initialParams[param] = "";
        });
        // setTemplateParams(initialParams);
      }
    }
  }, [selectedTemplate]);

  useEffect(() => {
    if (incomingSelectedTemplate) {
      const template = templates.find(
        (t: any) => t.sid === incomingSelectedTemplate,
      );
      setSelectedTemplate(template);
    }
  }, [incomingSelectedTemplate, templates]);

  const handleSelectTemplate = (templateSid: string) => {
    console.log(templateSid);
    console.log("Finding in templates", templates);
    const template = templates.find((t: any) => t.sid === templateSid);
    console.log("Found template in templates", template);
    setSelectedTemplate(template);

    const templateBody = getTemplateBody(template);
    if (template && templateBody) {
      const params = extractTemplateParams(templateBody);
      const initialParams: Record<string, string> = {};
      params.forEach((param: string) => {
        initialParams[param] = "";
      });
      onSelectTemplate(template, initialParams);
    }
  };

  // const handleParamChange = (param: string, value: string) => {
  //   if (selectedTemplate) {
  //     const updatedParams = {
  //       ...Object.fromEntries(
  //         extractTemplateParams(selectedTemplate.types["twilio/quick-reply"].body)
  //           .map(p => [p, ''])
  //       ),
  //       [param]: value
  //     };
  //     onSelectTemplate(selectedTemplate, updatedParams);
  //   }
  // };

  return (
    <div>
      <EditableSelectComponent
        options={templates.map((template: any) => ({
          label: template.friendly_name,
          value: template.sid,
        }))}
        onChange={(templateSid: string) => handleSelectTemplate(templateSid)}
        editMode={true}
        value={selectedTemplate?.sid || ""}
        label="Selecteer een template"
      />
      {/* {selectedTemplate && (
        <div className="mt-4">
          <Card className="p-4 mb-4">
            <p>{selectedTemplate && selectedTemplate.types["twilio/quick-reply"] && replaceTemplateParams(selectedTemplate.types["twilio/quick-reply"].body, templateParams)}</p>
          </Card>
          <h4 className="font-semibold mb-2">Parameters:</h4>
          {Object.entries(templateParams).map(([param, value]) => (
            <Textarea
              key={param}
              label={`Parameter {{${param}}}`}
              value={value}
              onChange={(e) => handleParamChange(param, e.target.value)}
              className="mb-2"
            />
          ))}
        </div>
      )} */}
    </div>
  );
};

export default WhatsAppTemplateSelector;
